module.exports = __webpack_public_path__ + "static/media/icon_visitors_admin.4e24415d.svg";